/*
 * @param: scriptsMap - a json file which maps the file name to the hashed version 
 * 
 */
export function getPriorities(scriptsMap) {
    const priorities = [];

    priorities.push({ url: scriptsMap['cookieconsent.js'], is: 'script' });
    priorities.push({ url: scriptsMap['core.js'], is: 'script' });
    priorities.push({ url: 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js', is: 'script' });
    
    return priorities;
}

/*
 * @param: scriptsMap - a json file which maps the file name to the hashed version 
 * 
 */
export function getDeps(scriptsMap) {
    const deps = [];

    deps.push({ url: scriptsMap['foundation.js'], is: 'script' });
    deps.push({ url: scriptsMap['foundation-sites.js'], is: 'script' });

    if (window.oneadvanced.required.slick) {
        deps.push({ url: scriptsMap['slick-carousel.js'], is: 'script' });
    }

    if (window.oneadvanced.required.swiper) {
        deps.push({ url: '/Static/cdn/swiper-bundle-8.4.4.min.js', is: 'script' });
    }

    if (window.oneadvanced.required.angularjs) {
        deps.push({ url: scriptsMap['angular.js'], is: 'script' });
        deps.push({ url: scriptsMap['angular-lazy-image.js'], is: 'script' });
        deps.push({ url: scriptsMap['ang.js'], is: 'script' });
    }

    if (window.oneadvanced.required.iframeblock) {
        deps.push({ url: '/Static/cdn/iframeResizer-4.3.2.min.js', is: 'script' });
    }

    if (window.oneadvanced.required.regionbar) {
        deps.push({ url: 'https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js', is: 'script' });
    }

    if (window.oneadvanced.required.wistia) {
        deps.push({ url: 'https://fast.wistia.com/assets/external/E-v1.js', is: 'script' });
    }

    return deps;
}

/*
 * @param: scriptsMap - a json file which maps the file name to the hashed version 
 * 
 */
export function getBundles(scriptsMap) {
    const bundles = [];

    if (window.oneadvanced.required.navigation) {
        bundles.push({ url: scriptsMap['navigation.js'], is: 'script' });
    }

    if (window.oneadvanced.required.evpnavigation) {
        bundles.push({ url: scriptsMap['evpnavigation.js'], is: 'script' });
    }

    if (window.oneadvanced.required.autocomplete) {
        bundles.push({ url: scriptsMap['autocomplete_core.js'], is: 'script' });
    }

    if (window.oneadvanced.required.layout) {
        bundles.push({ url: scriptsMap['layout.js'], is: 'script' });
    }

    if (window.oneadvanced.required.carousellayoutblock) {
        bundles.push({ url: scriptsMap['carousellayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.casestudylayoutblock) {
        bundles.push({ url: scriptsMap['casestudylayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.productresourceblock) {
        bundles.push({ url: scriptsMap['productresourceblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.reactiveimageblock) {
        bundles.push({ url: scriptsMap['reactiveimageblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.responsivetabscarouselblock) {
        bundles.push({ url: scriptsMap['responsivetabscarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.showcasecarouselblock) {
        bundles.push({ url: scriptsMap['showcasecarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.statisticsblock) {
        bundles.push({ url: scriptsMap['statisticsblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.testimonialcarouselblock) {
        bundles.push({ url: scriptsMap['testimonialcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.rellax) {
        bundles.push({ url: '/Static/cdn/rellax-1.12.0.min.js', is: 'script' });
    }

    if (window.oneadvanced.required.customtablayoutblock) {
        bundles.push({ url: scriptsMap['customtablayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.backtotop) {
        bundles.push({ url: scriptsMap['backtotop.js'], is: 'script' });
    }

    if (window.oneadvanced.required.breadcrumbschema) {
        bundles.push({ url: scriptsMap['breadcrumbschema.js'], is: 'script' });
    }

    if (window.oneadvanced.required.vacancies) {
        bundles.push({ url: scriptsMap['vacancies.js'], is: 'script' });
    }

    if (window.oneadvanced.required.lazyload) {
        bundles.push({ url: scriptsMap['lazyload.js'], is: 'script' });
    }

    if (window.oneadvanced.required.observer) {
        bundles.push({ url: scriptsMap['observer.js'], is: 'script' });
    }

    if (window.oneadvanced.required.mobile) {
        bundles.push({ url: scriptsMap['mobile.js'], is: 'script' });
    }

    if (window.oneadvanced.required.advancedproductsnav) {
        bundles.push({ url: scriptsMap['advancedproductsnav.js'], is: 'script' });
    }

    if (window.oneadvanced.required.form && window.oneadvanced.required.form.tooltip) {
        bundles.push({ url: scriptsMap['form_tooltip.js'], is: 'script' });
    }

    if (window.oneadvanced.required.dropdownnavigationblock) {
        bundles.push({ url: scriptsMap['dropdownnavigationblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.herocarouselbannerblock) {
        bundles.push({ url: scriptsMap['herocarouselbannerblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.stickyheaderblock) {
        bundles.push({ url: scriptsMap['stickyheaderblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.stickyimageblock) {
        bundles.push({ url: scriptsMap['stickyimageblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.campaignpage) {
        bundles.push({ url: scriptsMap['campaignpage.js'], is: 'script' });
    }

    if (window.oneadvanced.required.billboardblock) {
        bundles.push({ url: scriptsMap['billboardblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.iframeblock) {
        bundles.push({ url: scriptsMap['iframeblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.alternativelanguageselectorservice) {
        bundles.push({ url: scriptsMap['alternativelanguageselectorservice.js'], is: 'script' });
    }

    if (window.oneadvanced.required.articlepage) {
        bundles.push({ url: scriptsMap['articlepage.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.productfinderblock) {
        bundles.push({ url: scriptsMap['productfinderblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.localnavigationblock) {
        bundles.push({ url: scriptsMap['localnavigationblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.megaheader) {
        bundles.push({ url: scriptsMap['megaheader.js'], is: 'script' });
    }

    if (window.oneadvanced.required.regionbar) {
        bundles.push({ url: scriptsMap['regionbarblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.storiescarouselitemblock) {
        bundles.push({ url: scriptsMap['storiescarouselitemblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.homepageheroareablock) {
        bundles.push({ url: scriptsMap['homepageheroareablock.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.timelineblock) {
        bundles.push({ url: scriptsMap['timelineblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcontactusblock) {
        bundles.push({ url: scriptsMap['refreshedcontactusblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcampaignbookademoblock) {
        bundles.push({ url: scriptsMap['refreshedcampaignbookademoblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedhelpmechooseblock) {
        bundles.push({ url: scriptsMap['refreshedhelpmechooseblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedresourcescarouselblock) {
        bundles.push({ url: scriptsMap['refreshedresourcescarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcustomerfeedbackcarouselblock) {
        bundles.push({ url: scriptsMap['refreshedcustomerfeedbackcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedourstoryhistorysliderblock) {
        bundles.push({ url: scriptsMap['refreshedourstoryhistorysliderblock.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.refreshedtablelayoutblock) {
        bundles.push({ url: scriptsMap['refreshedtablelayoutblock.js'], is: 'script' });
    }
    if (window.oneadvanced.required.refreshedproductsoftwaregalleryblock) {
        bundles.push({ url: scriptsMap['refreshedproductsoftwaregalleryblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedproductheroblock) {
        bundles.push({ url: scriptsMap['refreshedproductheroblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedfeaturestabsblock) {
        bundles.push({ url: scriptsMap['refreshedfeaturestabsblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedrecommendationcarouselblock) {
        bundles.push({ url: scriptsMap['refreshedrecommendationcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedtextovermediablock) {
        bundles.push({ url: scriptsMap['refreshedtextovermediablock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.videogridblock) {
        bundles.push({ url: scriptsMap['videogridblock.js'], is: 'script' });
    }

    bundles.push({ url: scriptsMap['initialisation.js'], is: 'script' });

    return bundles;
}